export const DISCUSSION_GROUP_LOCALE_ZHCHT = {
    submit: 'æäº¤',
    cancel: 'åæ¶',
    colleague: 'åäº',
    all: 'ææäººå¡å¯è¦',
    related: 'åç¸éäººå¡å¯è¦',
    confirm: 'ç¢ºå®',
    reply: 'åè¤',
    emptyMessage: 'æ«ç¡æ¸æ',
    placeholder: 'è«è¼¸å¥å§åæç´¢',
    notEmpty: 'æäº¤å§å®¹ä¸è½çºç©º',
    selectEmployee: 'é¸æå¡å·¥',
    next: 'ä¸ç´',
    emptySelected: 'æ¸ç©ºå·²é¸',
    emptyRight: 'è«å¨å·¦å´é¸æäººå¡',
    allOrg: 'å¨é¨çµç¹',
    selected: 'å·²é¸',
    section: 'é¨é',
    people: 'äººå¡',
    viewMore: 'æ¥çæ´å¤',
    per: 'äºº',
    pcs: 'å',
    emptyList: 'è¯ä¿äººçºç©º',
    advancedQuery: 'é«ç´æ¥è©¢'
};
